import { ROUTE_NAMES } from './routeNames.const'

export const routeLanding = {
  path: '/welcome',
  name: ROUTE_NAMES.landing,
  component: () =>
    import(
      /* webpackChunkName: "Landing" */ 'src/pages/LandingPage/LandingPage.vue'
    ),
}
